module.exports = __webpack_public_path__ + "img/exciting-penguin.2b36927c.svg";